import React from "react";
import { Outlet } from "react-router-dom";

const DocsLayout = () => {
  return (
    <div className="w-full min-w-0 overflow-x-hidden flex justify-center mb-16 px-4 box-border">
      <div className="w-full max-w-md min-w-0">
        <Outlet />
      </div>
    </div>
  );
};

export default DocsLayout;
